import { Injectable, signal } from '@angular/core';
import { MessageTemplatePlaceholder } from '../message-generate.model';

@Injectable({ providedIn: 'root' })
export class TemplateTransformerService {
	readonly properties = signal<MessageTemplatePlaceholder[]>([]);

	replaceValuesWithKeys(text: string): string {
		let result = text;

		for (const { systemValue, displayValue } of this.properties()) {
			const pattern = new RegExp(`{{\\s*${this.escapeRegex(systemValue)}\\s*}}`, 'g');
			result = result.replace(pattern, `{{ ${displayValue} }}`);
		}

		return result;
	}

	replaceKeysWithValues(text: string): string {
		let result = text;

		for (const { displayValue, systemValue } of this.properties()) {
			const pattern = new RegExp(`{{\\s*${this.escapeRegex(displayValue)}\\s*}}`, 'g');
			result = result.replace(pattern, `{{ ${systemValue} }}`);
		}

		return result;
	}

	private escapeRegex(input: string): string {
		return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
}
